export enum PricePolicySearchType {
  All = 'All',
  GlobalOnly = 'Global',
  PartnerPriceOnly = 'PartnerPriceOnly',
}
